import React, { useContext, useState } from 'react'
import { FormContext } from './FormContext'
import { generateUrl } from './generateUrl'
import { Preview } from './Preview'
import { CopyUrl } from './CopyUrl'

interface UrlGenerationSectionProps {
  urlButtonText: string
  urlFormLabel: string
}
export const UrlGenerationSection: React.FC<UrlGenerationSectionProps> = ({ urlButtonText, urlFormLabel }) => {
  const { baseUrl, contractId, vehicleId, shouldShare } = useContext(FormContext)
  const [visibilityClass, setVisibilityClass] = useState('hidden')
  const url = generateUrl(baseUrl, contractId, vehicleId, shouldShare)

  return (
    <div id='custom-url'>
      <div id='generate-url-button'>
        <button className='post-button' onClick={() => setVisibilityClass('')}>{urlButtonText}</button>
      </div>
      <div id='custom-generated-url' className={visibilityClass}>
        <div>
          <label>{urlFormLabel}</label>
        </div>
        <div>
          <div id='generated-url-container'>
            <p id='generated-url'>{url}</p>
            <Preview url={url} />
            <CopyUrl url={url} />
          </div>
        </div>
      </div>
    </div>
  )
}
